<template>
  <div>
    <el-table
      v-if="showTable"
      :data="statusList"
      border
      :header-row-style="tableHeaderStyle"
      :header-cell-style="tableHeaderStyle"
      empty-text="ไม่พบข้อมูล"
    >
      <el-table-column
        type="index"
        label="ลำดับ"
        header-align="center"
        align="center"
        sortable
        width="80"
      ></el-table-column>
      <el-table-column
        prop="courseName"
        label="รายวิชาหลักสูตร"
        header-align="center"
        sortable
        :width="widthMax < 575.98 ? '170' : widthMax < 1199 ? '' : ''"
      ></el-table-column>
        <el-table-column
          prop="durationTime"
          label="ระยะเวลาในการเปิด-ปิดหลักสูตร"
          width="350"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope"
            >{{ scope.row.durationTime.open | dateTimeThShort }} -
            {{ new Date(scope.row.durationTime.close).setHours(23,59,59) | dateTimeThShort }}</template
          >
        </el-table-column>
      <el-table-column
        prop="createdAt"
        label="วันและเวลาที่ขออนุมัติ"
        :width="
          widthMax < 767.98
            ? '160'
            : widthMax < 1199
            ? '160'
            : widthMax > 1200
            ? '250'
            : ''
        "
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.createdAt | dateTimeTh }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="showAction"
        prop="status"
        label
        width="95"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <el-dropdown trigger="click" class="cursor-pointer">
            <span class="el-dropdown-link">
              {{
                scope.row.status == 0
                  ? "รออนุมัติ"
                  : scope.row.status == 0
                  ? "อนุมัติ"
                  : "ไม่อนุมัติ"
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                ><div @click="saveStatusCourse(scope.row._id, 1)" style="color:#00B27D;">
                  อนุมัติ
                </div></el-dropdown-item
              >
              <el-dropdown-item
                ><div @click="saveStatusCourse(scope.row._id, 2)">
                  ไม่อนุมัติ
                </div></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showDel"
        label
        width="95"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div class="flex-display ai-center js-center">
            <div class="box-action">
              <el-popconfirm
                confirmButtonText="ใช่"
                cancelButtonText="ไม่"
                icon="el-icon-info"
                iconColor="red"
                title="ท่านต้องการลบรายการนี้ใช่หรือไม่"
                @onConfirm="delNotAllowCourse(scope.row.courseId)"
              >
                <div
                  slot="reference"
                  class="circle-action color-bg-danger-lighter"
                >
                  <i class="fas fa-trash-alt"></i>
                </div>
              </el-popconfirm>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";
export default {
  props: {
    showAction: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showDel: {
      type: Boolean,
      default() {
        return false;
      },
    },
    statusList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {},
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true,
      page: 1,
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    changePage(page) {
      this.page = page;
    },
    print() {
      window.print();
    },
    saveStatusCourse(id, status) {
      this.$emit("saveStatusCourse", id, status);
    },
    delNotAllowCourse(id) {
      this.$emit("delNotAllowCourse", id);
    },
  },
};
</script>